// v2.23 — montant compté pour un élève à une séance de collectif (somme = montant vert sous la date).
// Règle d'origine : présent (hors aide et essai) → paiement enregistré à cette séance, sinon le prix convenu.
export const sessionAmount = (att, paid, billing, course) => {
  if (!att?.present) return { amount: 0, source: null, reason: 'absent' };
  if (att.is_aide) return { amount: 0, source: null, reason: 'aide' };
  if (att.is_trial) return { amount: 0, source: null, reason: 'essai' };
  if (paid > 0) return { amount: paid, source: 'paid' };
  return { amount: parseFloat(billing?.price_per_class || course?.price_per_class || 0), source: 'price' };
};

// paiements de chaque élève enregistrés à cette séance (même date/heure que la séance)
export const paidBySession = (session, coursePayments) => {
  const map = {};
  coursePayments.filter(p => p.date === session.datetime_start).forEach(p => {
    map[p.student_id] = (map[p.student_id] || 0) + parseFloat(p.amount || 0);
  });
  return map;
};

export const sessionTotal = (session, enrolledStudents, coursePayments, course) => {
  const paid = paidBySession(session, coursePayments);
  return enrolledStudents.reduce((sum, { student_id: sid, billing }) => {
    const att = session.attendances?.find(a => a.student_id === sid);
    return sum + sessionAmount(att, paid[sid] || 0, billing, course).amount;
  }, 0);
};
